export enum isSiteLiveActionTypes {
    SetIsSiteLiveType = "SET_ISSITELIVE",
}

export const setIsSiteLive = (data: any) => ({
    type: isSiteLiveActionTypes.SetIsSiteLiveType,
    payload: data
});
